export default __webpack_public_path__ + "static/google_Desktop11-f9fe3f3ff17f26b7fa9f329168298346.svg";